import styled from '@emotion/styled';
import { FormControl, FormHelperText, InputLabel, Select, Switch } from '@mui/material';

export const StyledInputLabel = styled(InputLabel)`
  font-size: 1rem;
  color: #333;
  margin-bottom: 8px;
  text-align: left;
  & .required {
    color: #d32f2f;
  }
`;

export const StyledFormControl = styled(FormControl)`
  margin-bottom: 16px;
  text-align: left;
  .MuiInputBase-root {
    background: #fff;
    padding: 15px 0px;
    border-radius: 14px;

    .MuiList-root .MuiMenuItem-root {
      font=size: 14px;
    }
  }
`;

export const StyledSelect = styled(Select)`
  height: 40px;

  & .MuiOutlinedInput-root {
    height: 40px;

    & fieldset {
      border-color: #ccc;
    }
    &:hover fieldset {
      border-color: #888;
    }
    &.Mui-focused fieldset {
      border-color: #1976d2;
    }
    & .MuiMenuItem-root {
      text-align: left;
    }
  }
  & .MuiSelect-select {
    border-radius: 10px; // Adjust the border-radius here
  }
  & .MuiOutlinedInput-notchedOutline {
    border-radius: 10px; // Ensure the border-radius is applied to the dropdown outline
  }
`;

export const StyledFormHelperText = styled(FormHelperText)`
  // color: #ff0000;
  color: #d32f2f;
  margin-left: 0px;
  font-size: 14px;
  font-family: 'Soleil', sans-serif;
  .Mui-error {
    font-size: 14px;
    font-family: 'Soleil', sans-serif;
    color: #d60000;
  }
`;

export const StyledCheckbox = styled(FormControl)`
  .MuiSvgIcon-root {
    width: 28px;
    height: 28px;
    margin-left: -10px;
  }
  .MuiCheckbox-sizeMedium {
    color: #758591;
  }
  .MuiCheckbox-sizeMedium.Mui-error {
    color: #d32f2f;
  }
  .MuiCheckbox-sizeMedium.Mui-checked {
    color: #a1ce5e;
  }
  .MuiSwitch-root .MuiSwitch-track {
    background: white;
  }
  .MuiSwitch-root .MuiSwitch-thumb {
    background: #a1ce5e;
  }
  .MuiList-root .MuiMenu-list .MuiMenuItem-root {
    font-size: 14px;
  }
  .CustomCheckbox {
    position: relative;
    padding-left: 34px;
    margin-top: 23px;
    .MuiCheckbox-root {
      position: absolute;
      top: -13px;
      left: 0;
    }
  }
`;

export const StyledSwitch = styled(Switch)`
  width: 69px;
  .MuiSwitch-switchBase {
    .Mui-checked {
      .MuiSwitch-track {
        background-color: #a1ce5e;
        width: 75px;
        height: 26px;
      }
    }
  }
  .MuiSwitch-thumb {
    color: #fff;
    width: 26px;
    height: 26px;
    margin-top: -4px;
  }
  .MuiSwitch-track {
    background-color: #a1ce5e;
    width: 75px;
    height: 26px;
    border-radius: 15px;
  }
  .css-byenzh-MuiButtonBase-root-MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track {
    background-color: #758591;
  }
  .Mui-checked {
    .MuiSwitch-track {
      background-color: #a1ce5e;
      width: 69px;
      height: 26px;
      border-radius: 15px;
    }
    .MuiSwitch-thumb {
      color: #fff;
    }
  }
`;
